export const getSamlIsLoading = state => state.sso.saml.get.loading;
export const getSamlSuccess = state => state.sso.saml.get.success;
export const getSamlIsError = state => state.sso.saml.get.error;
export const getAzureadIsLoading = state => state.sso.azuread.get.loading;
export const getAzureadSuccess = state => state.sso.azuread.get.success;
export const getAzureadIsError = state => state.sso.azuread.get.error;